// Tipos TypeScript para ExpedienteSolicitud
// Alineado con migrofast/app/schemas/expediente_solicitud.py

export type TipoSolicitud =
  | 'documento'
  | 'informacion'
  | 'aclaracion'
  | 'documentacion_adicional';

export type EstadoSolicitud =
  | 'pendiente'
  | 'en_proceso'
  | 'completada'
  | 'cancelada';

export interface ExpedienteSolicitudRead {
  id: string;
  expediente_id: string;
  lawyer_id: string;
  client_id: string;
  tipo: TipoSolicitud;
  titulo: string;
  descripcion: string;
  requiere_archivo: boolean;
  requiere_chat: boolean;
  estado: EstadoSolicitud;
  fecha_limite?: string | null;
  respuesta_texto?: string | null;
  respuesta_archivo_id?: string | null;
  conversacion_id?: string | null;
  created_at: string;
  updated_at: string;
  responded_at?: string | null;
  // Campos opcionales de WithRelations
  lawyer_name?: string | null;
  client_name?: string | null;
  expediente_title?: string | null;
}

export interface ExpedienteSolicitudCreate {
  expediente_id: string;
  client_id: string;
  tipo: TipoSolicitud;
  titulo: string;
  descripcion: string;
  requiere_archivo?: boolean;
  requiere_chat?: boolean;
  fecha_limite?: string | null;
}

export interface ExpedienteSolicitudUpdate {
  estado?: EstadoSolicitud;
  respuesta_texto?: string | null;
  respuesta_archivo_id?: string | null;
  conversacion_id?: string | null;
}

export const TIPO_SOLICITUD_LABELS: Record<TipoSolicitud, string> = {
  documento: 'Documento',
  informacion: 'Información',
  aclaracion: 'Aclaración',
  documentacion_adicional: 'Documentación adicional',
};

export const ESTADO_SOLICITUD_LABELS: Record<EstadoSolicitud, string> = {
  pendiente: 'Pendiente',
  en_proceso: 'En proceso',
  completada: 'Completada',
  cancelada: 'Cancelada',
};
